import { useState, useEffect, FormEvent, useContext } from 'react';
import { Button, Loader } from '../Styles';
import { cadastrar5w2h, atualizar5w2h } from '../../services/desafios';
import { Props5w2hPriorizacao } from "../../interfaces/5w2h"
import { toast } from 'react-toastify';
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { criptografarDado } from '../../helpers';
import { listarMembrosProjeto } from '../../services/projetos';
import { membrosResponsaveis } from '../../interfaces/desafios';
import { useLocation } from 'react-router-dom';

function Modal5w2h({ desafio, setDesafio }: Props5w2hPriorizacao) {
  const { modalExibir, atualizarDados } = useContext(ModalEstadoContext)

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");

  const [responsaveis, setResponsaveis] = useState<membrosResponsaveis[]>([]);

  const [processando, setProcessando] = useState(false);
  const [quem, setQuem] = useState(desafio?.estrategia5w2h?.quem || '');
  const [onde, setOnde] = useState(desafio?.estrategia5w2h?.onde || '');
  const [quando, setQuando] = useState(desafio?.estrategia5w2h?.quando || '');
  const [quanto, setQuanto] = useState(desafio?.estrategia5w2h?.quanto || '');
  const [oQue, setOque] = useState(desafio?.estrategia5w2h?.oQue || '');
  const [porque, setPorque] = useState(desafio?.estrategia5w2h?.porque || '');
  const [como, setComo] = useState(desafio?.estrategia5w2h?.como || '');

  const createSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setProcessando(true);
    if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")
    if (!desafio?.id) return toast.error("Não foi possivel encontrar o desafio.")
    try {
      const payload = {
        quem, onde, quando, quanto, oQue, porque, como, idProjeto, idDesafio: desafio.id
      };
      const resposta = await cadastrar5w2h(payload);
      if (resposta.status === 201) {
        setProcessando(false);
        modalExibir("")
        toast.success("Estratégia 5w2h Criado com Sucesso.")
        setDesafio("")
        atualizarDados()
      }
    } catch (error) {
      setProcessando(false);
      toast.error("Erro ao criar a Estratégia 5w2h.")
    }
  };

  const updateSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setProcessando(true);
    if (!desafio?.estrategia5w2h) return toast.error("Não foi possivel encontrar o formulario 5w2h")
    try {
      const formData = { quem, onde, quando, quanto, oQue, porque, como };
      const id5W2HCript = criptografarDado(desafio.estrategia5w2h.id.toString())
      const resposta = await atualizar5w2h(id5W2HCript, formData);
      if (resposta.status === 200) {
        setProcessando(false);
        modalExibir("")
        toast.success("Estratégia 5w2h Atualizado com Sucesso.")
        atualizarDados()
      }
    } catch (error) {
      setProcessando(false);
      toast.error("Erro ao criar a Estratégia 5w2h.")
    }
  };

  useEffect(() => {
    const listarMembrosResponsaveis = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

      try {
        const idProjetoEncoded = encodeURIComponent(idProjeto)
        const resposta = await listarMembrosProjeto(idProjetoEncoded);
        if (resposta.status === 200) {
          return setResponsaveis(resposta.data)
        }

      } catch (error) {
        toast.error("Erro ao listar todos os membros do Projeto.");
      }
    };
    listarMembrosResponsaveis()

  }, [idProjeto])

  return (
    <div id='fundoModal'>
      <section className={'containerModalCentro'}>
        <span className='novoContainerTitulo'>
          <h1>Estratégia 5w2h</h1>
        </span>

        <form className="formModalNovo" onSubmit={desafio?.estrategia5w2h ? updateSubmit : createSubmit}>
          <section>
            <span>
              <label>Quem será o Responsável (Who)</label>
              <select value={quem} onChange={(e) => setQuem(e.target.value)} required>
                <option value="" disabled>Selecione um Responsável</option>
                {responsaveis.map((responsavel) => (
                  <option value={responsavel.usuario.id} key={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
                ))
                }
              </select>
            </span>
            <span>
              <label>Onde será Feito (Where)</label>
              <input type="text" defaultValue={onde} maxLength={500} onChange={(e) => setOnde(e.target.value)} placeholder='Digite onde será feito' required />
            </span>
          </section>
          <section>
            <span>
              <label>Quando será Feito (When)</label>
              <input type="text" defaultValue={quando} maxLength={100} onChange={(e) => setQuando(e.target.value)} placeholder='Digite Quando será Feito' required />
            </span>
            <span>
              <label>Quanto custará (How Much)</label>
              <input type="text" defaultValue={quanto} maxLength={100} onChange={(e) => setQuanto(e.target.value)} placeholder='Digite Quanto Custará' required />
            </span>
          </section>
          <section>
            <span>
              <label>Como será Feito (How)</label>
              <textarea defaultValue={como} rows={3} cols={30} className='areaTexto' maxLength={100} onChange={(e) => setComo(e.target.value)} placeholder='Digite como será feito' required></textarea>
            </span>
          </section>
          <section>
            <span>
              <label>O que deverá ser feito (What)</label>
              <textarea defaultValue={oQue} rows={8} cols={30} className='areaTexto' maxLength={500} onChange={(e) => setOque(e.target.value)} placeholder='Digite o que deverá ser feito' required></textarea>
            </span>
          </section>
          <section>
            <span>
              <label>Por que deve ser feito (Why)</label>
              <textarea defaultValue={porque} rows={8} cols={30} className='areaTexto' maxLength={500} onChange={(e) => setPorque(e.target.value)} placeholder='Digite por que deve ser feito ' required></textarea>
            </span>
          </section>
          <span className="botoesContainer">
            <Button type="button" cor="cancelar" isLoading={processando} onClick={() => modalExibir("")}>
              Cancelar
            </Button>
            <Button type="submit" cor="salvar" isLoading={processando}>
              {!processando && "Salvar"}
              {processando && <Loader isLoading={processando} />}
            </Button>
          </span>
        </form>
      </section>
    </div>
  );
}

export default Modal5w2h;
